const data = [
    {
      id: 1,
      sthan: 'Bulls',
      neuntam: 'Chicago',
      jydasejyda:""
    },
    {
      id: 2,
      sthan: 'Suns',
      neuntam: 'Phoenix',
      jydasejyda:""
    },
    {
      id: 3,
      sthan: 'Magic',
      neuntam: 'Orlando',
      jydasejyda:""
    },
    {
      id: 4,
      sthan: 'Lakers',
      neuntam: 'Los Angeles',
      jydasejyda:""
    },
    {
      id: 5,
      sthan: 'Celtics',
      neuntam: 'Boston',
      jydasejyda:""
    },
    {
      id: 6,
      sthan: 'Hornets',
      neuntam: 'Charlotte',
      jydasejyda:""
    },
    {
      id: 7,
      sthan: 'Knicks',
      neuntam: 'New York',
      jydasejyda:""
    },
  ];
  
  export default data;